export const isMobile = (): boolean => !window.matchMedia('screen and (min-width: 1024px)').matches;
